import { Controller } from "@hotwired/stimulus"
import { visitIndexWithOptions } from "../utils/index_options_visit"

// Sur-header « filtres importants » (pills hors tableau) — met à jour options.f puis recharge l'index.
export default class extends Controller {
  static params = ["attribute", "year", "value"]

  static values = {
    options: { type: Object, default: {} },
    path: String,
    searchResultsFrameId: String,
  }

  selectYear(event) {
    event.preventDefault()
    event.stopPropagation()

    const target = event.currentTarget
    const attribute =
      event.params.attribute || target.dataset.indexImportantFiltersAttributeParam
    const year =
      event.params.year ?? target.dataset.indexImportantFiltersYearParam ?? ""
    if (!attribute) return

    const options = structuredClone(this.resolvedOptions())
    const f = { ...(options.f || {}) }

    if (!year) {
      delete f[attribute]
    } else {
      f[attribute] = {
        [this.filterId()]: {
          o: "between",
          v: ["", `${year}-01-01`, `${year}-12-31`],
        },
      }
    }

    if (Object.keys(f).length === 0) {
      delete options.f
    } else {
      options.f = f
    }

    delete options.page

    this.visit(options)
  }

  selectEnum(event) {
    event.preventDefault()
    event.stopPropagation()

    const target = event.currentTarget
    const attribute =
      event.params.attribute || target.dataset.indexImportantFiltersAttributeParam
    const value =
      event.params.value ?? target.dataset.indexImportantFiltersValueParam ?? ""
    if (!attribute) return

    const options = structuredClone(this.resolvedOptions())
    const f = { ...(options.f || {}) }

    if (!value) {
      delete f[attribute]
    } else {
      f[attribute] = {
        [this.filterId()]: { v: [value] },
      }
    }

    if (attribute === "section_tag") {
      delete f.sub_category_tag
    }

    if (Object.keys(f).length === 0) {
      delete options.f
    } else {
      options.f = f
    }

    delete options.page

    this.visit(options)
  }

  resolvedOptions() {
    const fromValue = this.optionsValue || {}
    const fromFrame = embeddedIndexOptions(this.element)
    return { ...fromFrame, ...fromValue }
  }

  filterId() {
    return String(Math.floor(Math.random() * 90000) + 10000)
  }

  visit(options) {
    visitIndexWithOptions({
      path: this.resolvedPath(),
      options,
      element: this.element,
      searchResultsFrameId: this.searchResultsFrameIdValue,
    })
  }

  resolvedPath() {
    if (this.pathValue) return this.pathValue
    return embeddedIndexPath(this.element) || window.location.pathname
  }
}

function embeddedTurboFrame(element) {
  return element?.closest?.("turbo-frame[data-turbo-index-embedded]")
}

function embeddedIndexSrc(element) {
  const frame = embeddedTurboFrame(element)
  if (!frame) return null
  return frame.getAttribute("src") || frame.dataset.lazySrc || null
}

function embeddedIndexOptions(element) {
  const src = embeddedIndexSrc(element)
  if (!src) return {}

  try {
    const raw = new URL(src, window.location.origin).searchParams.get("options")
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

function embeddedIndexPath(element) {
  const src = embeddedIndexSrc(element)
  if (!src) return null

  try {
    return new URL(src, window.location.origin).pathname
  } catch {
    return null
  }
}
